import React from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log(API_BASE_URL)


export default function AppDownloadPage() {
  const { platform } = useParams(); // URL에서 platform 값을 가져옴
  const lowerPlatform = platform.toLowerCase(); // android / ios
console.log(platform, lowerPlatform);
  //const handleDownload = (plat) => {
  //  const serverBase = API_BASE_URL;
  //  window.location.href = `${serverBase}/apk/${plat}`;
  //};

const handleDownload = (plat) => {
  if (plat === 'android') {
    // Android는 원스토어로 바로 이동
    window.location.href = 'https://m.onestore.co.kr/v2/ko-kr/app/0001002772';
  } else {
    // iOS는 서버에서 다운로드
    window.location.href = `${API_BASE_URL}/apk/${plat}`;
  }
};

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
          padding: '50px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            width: '200px',
            height: '80px',
            marginBottom: '40px',
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.25)',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8fafc'
          }}>
            <img src="/media/logo.png" alt="앱 로고" style={{ width: '90%', height: '90%', objectFit: 'contain', borderRadius: '12px' }} />
          </div>

          <p style={{
            fontSize: '18px',
            color: '#4b5563',
            marginBottom: '45px',
            lineHeight: '1.7',
            fontWeight: '400',
            maxWidth: '400px'
          }}>
            최신 버전의 파일을 안전하게 다운로드하여<br/>모바일에서 바로 설치하세요.
          </p>

          {/* Android 버튼 */}
          {lowerPlatform === 'android' && (
            <button
              onClick={() => handleDownload('android')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '280px',
                background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                color: 'white',
                fontWeight: '600',
                fontSize: '16px',
                padding: '18px 32px',
                borderRadius: '14px',
                textDecoration: 'none',
                boxShadow: '0 8px 25px rgba(59, 130, 246, 0.35)',
                transition: 'all 0.3s ease',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '15px'
              }}
            >
              <span style={{ marginRight: '8px' }}>📱</span>Android APK 다운로드
            </button>
          )}

          {/* iOS 버튼 */}
          {lowerPlatform === 'ios' && (
            <button
              onClick={() => handleDownload('ios')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '280px',
                background: 'linear-gradient(135deg, #f97316, #c2410c)',
                color: 'white',
                fontWeight: '600',
                fontSize: '16px',
                padding: '18px 32px',
                borderRadius: '14px',
                textDecoration: 'none',
                boxShadow: '0 8px 25px rgba(249, 115, 22, 0.35)',
                transition: 'all 0.3s ease',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              <span style={{ marginRight: '8px' }}>🍎</span>iOS 다운로드
            </button>
          )}

        </div>
      </div>
    </div>
  );
}


